
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 4.458V4a1 1 0 012 0v.474a5.503 5.503 0 014.39 4.54.998.998 0 01.067.361v5.429l1.478 1.478c.63.63.184 1.707-.707 1.707H5.5c-.89 0-1.337-1.077-.707-1.707l1.664-1.664V9.375c0-.127.024-.249.067-.36A5.503 5.503 0 0111 4.457zm4.75 11.467a1 1 0 01-.293-.707v-5.61a1.007 1.007 0 01-.021-.123 3.5 3.5 0 00-6.957 0 1.007 1.007 0 01-.022.123v5.424a1 1 0 01-.293.707l-.25.25h7.9l-.064-.064zM10 19h4a2 2 0 11-4 0z"}})])
          )
        }
      }
    